// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Content":"Content-wsffj7kbygyb3tf8shn2hzytjgan9vw6n3sk65dahjdf6c92qfre4e6ehfrm7r6wgrqe3uq87yv3pf9vk7mey18tn3xf37akws68k","loading":"loading-213mrvnthssj4tcqz6yz3yezf5erp6w26me85rc3mwrfvad9kcq11t6n47cxs8j39hgdqgvt1z8apvgmkznycp74upavjdafjp2cmwg","pulse":"pulse-jb5x6793mmtn2shsqwszgzdkrumy4ta9avgjf2w4jw7h5uqvvvbn39gjbaetu8k3bcrwv6qac79grzyc61xc4m3encf42u38xg89g7"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Whistleblowing/Whistleblowing.module.scss
// module id = 1792
// module chunks = 0